import { computed } from 'mobx';
import { profileTypes } from '../../config/types';
import UserImplDependedRefState from './abstract/UserImplDependedRefState';

class PublicAccountState extends UserImplDependedRefState {
  constructor(root) {
    super(root, {
      pathGetter: (userImpl) => `profiles/${userImpl.uid}/account/public`,
    });
  }

  handleSnapshotSuccess(snapshot) {
    super.handleSnapshotSuccess(snapshot);
    if (!snapshot.exists()) {
      this.error = "Public account doesn't exists";
    }
  }

  get isLandlordType() {
    return [profileTypes.LANDLORD, profileTypes.MANAGER].includes(
      this.data?.profileType
    );
  }

  get isTenantType() {
    return [profileTypes.TENANT].includes(this.data?.profileType);
  }
}

PublicAccountState.annotations = {
  ...UserImplDependedRefState.annotations,
  isLandlordType: computed,
  isTenantType: computed,
};

export default PublicAccountState;
